import React from 'react'
import { ClickAwayListener, Fade, Popper } from '@mui/material'
import { track } from '@SonarCX/lib/mixpanel'

import Editor from '../../organisms/LexicalEditor'
import useStyles from './styles'

const noop = () => {}
interface TaskDescriptionPreviewModalProps {
  description: string
  onClose: () => void
  parentRef: any
  shouldCheckClose: boolean
}
const TaskDescriptionPreviewModal: React.FC<
  TaskDescriptionPreviewModalProps
> = ({ description, onClose, parentRef, shouldCheckClose }) => {
  const [hasBeenHovered, setHasBeenHovered] = React.useState(false)

  const classes = useStyles()

  const handleMouseEnter = React.useCallback(() => {
    setHasBeenHovered(true)
  }, [])

  const handleMouseLeave = React.useCallback(() => {
    if (hasBeenHovered) {
      onClose()
    }
  }, [hasBeenHovered, onClose])

  React.useEffect(() => {
    track('TASK_DESCRIPTION_PREVIEW_OPENED')
  }, [])

  React.useEffect(() => {
    if (shouldCheckClose) {
      if (!hasBeenHovered) {
        onClose()
      }
    }
  }, [shouldCheckClose, hasBeenHovered, onClose])

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Popper
        open={true}
        disablePortal={false}
        anchorEl={parentRef?.current}
        style={{ zIndex: '1299' }}
        placement='right'
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps}>
            <div
              className={classes.root}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <Editor
                disableImages
                placeholder=' '
                onChange={noop}
                enabled={false}
                showSpeechToText={false}
                value={description}
              />
            </div>
          </Fade>
        )}
      </Popper>
    </ClickAwayListener>
  )
}

export default TaskDescriptionPreviewModal
